module.exports = __webpack_public_path__ + "img/c6bfe83.jpg";